import { render, staticRenderFns } from "./SendMoneyForm.vue?vue&type=template&id=0c3d8f1d"
import script from "./SendMoneyForm.vue?vue&type=script&lang=ts"
export * from "./SendMoneyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports